import { Component,OnInit,OnDestroy, ViewChild,ElementRef, inject } from '@angular/core';
import { StaticdataService } from 'src/app/services/staticdata.service';
import {FormBuilder, Validators} from '@angular/forms';
import { FMSModulesService } from 'src/app/services/fmsmodules.service';
import { UserInfo, UserInfoService } from 'src/app/services/user-info.service';
import { ColorsService } from 'src/app/services/colors.service';
import {   MatSlideToggleChange, MatSlideToggle } from '@angular/material/slide-toggle';
import { Subscription } from 'rxjs/internal/Subscription';
import { Router ,ActivatedRoute} from '@angular/router';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {FormControl, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatAutocompleteSelectedEvent, MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatChipInputEvent, MatChipsModule} from '@angular/material/chips';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {LiveAnnouncer} from '@angular/cdk/a11y';
import { LoginService } from 'src/app/services/login.service';
import { UserService } from 'src/app/services/user.service';
import {PaymentConfigService}  from 'src/app/services/payment-config.service'
import { UserPrivilegeService } from 'src/app/services/user-privilege.service';
import { environment } from "../../../environments/environment"
import { DocumentService } from 'src/app/services/document.service';
import {TripService} from 'src/app/services/trip.service'
@Component({
  selector: 'app-application',
  templateUrl: './application.component.html',
  styleUrls: ['./application.component.css']
})
export class ApplicationComponent implements OnInit, OnDestroy{
  separatorKeysCodesTo: number[] = [ENTER, COMMA];

  whereTo:any=[];
  ToCtrl = new FormControl([]);
  filteredTo: Observable<any[]>;
  
  wherecity: any[] = [''];
  @ViewChild('airportToInput') ToInput!: ElementRef<HTMLInputElement>;

  announcer = inject(LiveAnnouncer);


  @ViewChild('slideToggle') slideToggle!: MatSlideToggle;
  showAdminShowMenu = true;
  isShowing = true;
  isExpanded=true;
  currentModule : string|undefined;
  currentModuleCode : string|undefined; 
  currentUserPrivileges : any;
  subs! : Subscription;
  username : string | undefined;
  displayname : string|undefined;
  parentUser:string|undefined;
  parentUserExist:boolean=false;
  isMenuOpen = true;
  invalidCredentialMsg:boolean=false
  contentMargin = 240;
  isslide:boolean=false;
  userType:any
  adminhide:boolean=true;
  emulateEmail:any

adminshow:boolean=false;
  task: string[] = [
    'Clearning out my closet', 'Take out trash bins', 'Wash car', 'Tank up the motorcycles', 'Go for flight training'
  ]

  onToolbarMenuToggle() {
    this.isslide=true;
    this.isMenuOpen = !this.isMenuOpen;

    if(!this.isMenuOpen) {
      this.contentMargin = 70;
    } else {
      this.contentMargin = 240;
    }
  }
  onToolbarMenuTogglee() {
    this.isslide=false;
    this.isMenuOpen = !this.isMenuOpen;

    if(!this.isMenuOpen) {
      this.contentMargin = 70;
    } else {
      this.contentMargin = 240;
    }
  }
isadminselect:boolean=false;
firstFormGroup = this._formBuilder.group({
  firstCtrl: ['', Validators.required],
});
secondFormGroup = this._formBuilder.group({
  secondCtrl: ['', Validators.required],
});
isLinear = false;
color:any
showNav:boolean=false;
token:any={
  displayName:'',
  userName:'',
  userType:''
}
userUuid:any
stoggle:boolean=false;
menuItems:any={
  manualCart:null,
  manageCart:null,
  adminMode:null,
  aiDashboard:null
}
menuItem:any

  constructor(private TripService:TripService,private DocumentService:DocumentService,private PaymentConfigService:PaymentConfigService,private staticdataservice : StaticdataService,private ColorsService :ColorsService,private route:ActivatedRoute,
    private _formBuilder: FormBuilder, private fmsModuleService : FMSModulesService,private UserService:UserService,
    private userInfoService : UserInfoService,  private loginService : LoginService, private router : Router,private userPrivileges:UserPrivilegeService) {
//        let storedElementData:any = sessionStorage.getItem('fullscreen');
//       console.log(storedElementData)
// if(storedElementData==='true'){

//   this.openfullscreen()

  
//      }
  this.ENABLE_TRIP_MGMT()

      this.userPrivileges.userMenuPrivileges().then((menuPrivileges:any) => {
      this.menuItem = menuPrivileges.filter((item:any)=>item.label==='ProfileMenu')
this.menuItems.manualCart=this.menuItem[0]?.children?.filter((item:any)=>item.label==='Manual Cart')[0]?.label
this.menuItems.manageCart=this.menuItem[0]?.children?.filter((item:any)=>item.label==='Manage Cart')[0]?.label
this.menuItems.adminMode=this.menuItem[0]?.children?.filter((item:any)=>item.label==='Admin Mode')[0]?.label
this.menuItems.aiDashboard=this.menuItem[0]?.children?.filter((item:any)=>item.label==='AI Mode')[0]?.label

// console.log(this.menuItems)     

 /* for(let i=0;i<this.menuItems.length;i++)
       {
      if(this.menuItems[i].label==='Orders'){
         this.menuItems[i].label='Reports'
       }}*/
       //console.log(this.menuItems)
      
      } )
       .catch((error:any) => {
       //console.error(error); // Handle errors, if any
       });





        this.ColorsService.colors("","").then((color:any) => {
        this.color=color
       })
       .catch((error:any) => {
       });
      this.subs=new Subscription();
      this.setModule();
      this.setPrivileges();
     
      this.subs.add(this.userInfoService.getCurrentModuleChangeSubs().subscribe({next : () => this.setModule()}));
      //this.router.navigate(["/app/terminal"])
      this.userType=userInfoService.getUserType();
      this.username=userInfoService.getUsername();
      this.userUuid=this.userInfoService.getUserUuid()
      this.GetBalance()
      this.getActiveTripList()

      if(userInfoService.getParentUser()){
      //  console.log(userInfoService.getParentUser())
      this.parentUser=userInfoService.getParentUser();
      this.parentUserExist = true;
      }
     // console.log(this.parentUser);
      this.displayname=userInfoService.getUserDisplayname();
     
      this.subs.add(
        this.userInfoService.getUserInfoSubs().subscribe({next : (u : UserInfo) => {

         this.userType=u.type
         this.username=u.username;
          this.displayname=u.userDisplayname;
          
        }})
        
      )
      this.UserList()
      
      this.filteredTo = this.ToCtrl.valueChanges.pipe(
        startWith(''),
        map((state:any) => (state ? this._filterStates(state) : this.whereTo.slice())),
      );


     
    
  }
   private _filterStates(value: string): any[] {
    const filterValue = value.toLowerCase();
    this.showSuggestions();

    return this.whereTo.filter((state:any) => state.name.toLowerCase().includes(filterValue));
 
  }
  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
  showtermianl:boolean=false

  
  ngOnInit(): void {
    let currentRoute:any;
    currentRoute = this.router?.routerState?.snapshot?.url;
  this.route.queryParams.subscribe(params => {
    let data:any
    data=params
   if(data.name){
    this.token.displayName= this.decodeTransformedEmail(data?.name)}
    if(this.token.displayName){
      this.displayname=this.token.displayName
      //this.emulateUser()
    }
    const regexPattern = /^\/app\/flight[A-Za-z0-9?=&]*$/;
    
    if (currentRoute.match(regexPattern)){
     // console.log("======")
      this.showNav=true
    } else {
     // console.log("000000000")

      this.showNav=false
      //console.log(this.stoggle)
    
        this.stoggle=true
      
    }
      });
   
   this.staticdataservice.loadCountries();
    this.staticdataservice.loadStates();
    this.staticdataservice.loadCities();
  }
  
  
  isSlide(){
    this.isslide=true;
  }
  onAdminClick(){
    this.isadminselect=!this.isadminselect;
  }
  onAdminhideClick(){
    this.isadminselect=false;
  }
  
  setModule() {
    this.currentModuleCode = this.userInfoService.getCurrentModule();
    this.currentModule = this.currentModuleCode ? this.fmsModuleService.getModuleName(this.currentModuleCode) : undefined;
  }

  setPrivileges() {
    const userPrivileges:any =  this.userInfoService.getPrivileges();
    this.currentUserPrivileges = userPrivileges;
   // this.currentModule = this.currentModuleCode ? this.fmsModuleService.getModuleName(this.currentModuleCode) : undefined;
  }
  hasPermission(permission: string): boolean {
    return this.currentUserPrivileges.includes(permission);
  }
  ispopupthide:boolean=false
  openPopup() {
    //console.log(this.stoggle)
    this.router.navigate(["/app/settings"]);
  //  if ( this.slideToggle.checked===true) {
    
  //   this.showNav=false
  //   this.router.navigate(["/app/settings"]);
  // } else {
   
  //   this.router.navigate(["/app/flight"]);
  //   this.showNav=true
  // }


  }
  closePopup() {
    this.ispopupthide=false;
  
  }
  sidebar(){
    this.showNav=!this.showNav
  }
  hideNav(event:any){
   
   
   if (event === 'settings') {
     this.showNav=false

   } else{
    this.showNav=true

   }
  }
  UpdateUser(element:any){
    let currentRoute:any;
    currentRoute = this.router?.routerState?.snapshot?.url;
 
    let data:any
    const regexPattern = /^\/app\/flight[A-Za-z0-9?=&]*$/;
    
    if (currentRoute.match(regexPattern)){
      
      this.showNav=true
    } else {

      this.showNav=false
    }
    
  //  window.location.href = "/app/User?email="+this.transformEmail(element)
   window.open("/app/User?email="+this.transformEmail(element))

   // this.router.navigate(['/app/User'],{ queryParams:  element } );   
    
   }

   onClickCart(userName:any){
    // window.location.href = "/app/manage-carts"
    this.router.navigate(['/app/manage-carts'])
   }
   onClickCalendar(userName:any){
    this.router.navigate(['/app/calendar-cart'])

   }
   onClickExpense(){
    this.router.navigate(['/app/manage-expence'])

   }
   onCreateCart(userName:any){
    window.location.href = "/app/create-manual-cart"
   }
   
   transformEmail(email: string): string {
    let result = '';
  
    for (let i = 0; i < email.length; i++) {
      const char = email.charCodeAt(i);
      result += char.toString(16); // Convert the character code to a hexadecimal string
    }
  
    return result;
  }
  decodeTransformedEmail(encodedEmail: string): string {
    let result = '';
  
    for (let i = 0; i < encodedEmail.length; i += 2) {
      const hexChar = encodedEmail.slice(i, i + 2);
      const charCode = parseInt(hexChar, 16); // Convert the hexadecimal string to a character code
      result += String.fromCharCode(charCode);
    }
  
    return result;
  }
  signOut(){
    this.loginService
    .logout()
    .subscribe({
      next: (res: any) => {
        sessionStorage.clear();
       window.location.reload();
       this.router.navigate(["/partner_login"]);
      }, error: () => {
       sessionStorage.clear()
       window.location.reload();

       this.router.navigate(["/partner_login"]);
      }
    }
    )
  }
  manageFile(){
    this.router.navigate(["/app/manage-file-upload"]);

  }
 

  addTo(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    // Add our fruit
    if (value) {
      this.wherecity.push(value);
    }

    // Clear the input value
    event.chipInput!.clear();

    this.ToCtrl.setValue(null);
  }

  selectedTo(event:any): void {
   
    console.log(this.filteredTo)

    //this.emulateName=event.option.value.name
     this.emulateEmail=event.email
     this.ToCtrl.setValue(event.name);

    this.hideSuggestions()
  }
  isSuggestionsVisible:boolean=false
  highlightedIndex = -1;

  showSuggestions() {
    this.isSuggestionsVisible = true;
  }

  hideSuggestions() {
    setTimeout(() => {
      this.isSuggestionsVisible = false;
    }, 200); // Add delay to ensure the user click event is captured
  }

userlist:any=[]
  UserList(){
  
    this.userType=this.userType.toUpperCase()
      this.UserService.getUserList(this.userType)
      .subscribe({
        next : (res:any) => {
          if(res) {
           // console.log(res)
          let  data:any;
          data=res["result"]
          this.userlist=data
          this.whereTo=data
          // for (let i = 0; i < data.length; i++) {
            
          //   this.whereTo.push(data[i]?.name);

          // }
   
        }else{

        }},error : (err) => {
    
          console.error("Error in fetching data");
        }
      }
    )
    
  }
tripEnable:boolean=false
  ENABLE_TRIP_MGMT(){
  
      this.UserService.ENABLE_TRIP_MGMT()
      .subscribe({
        next : (res:any) => {
          if(res) {
         if(res.policyType==='TRIP_MGMT'){
          if(res.rule==='1'){
this.tripEnable=true
          }else 
          if(res.rule==='2'){
            this.tripEnable=true
                      }
          else{
            this.tripEnable=false

          }

         }
   
        }else{

        }
        // if(this.tripEnable){
        //   this.router.navigate(["/app/flight"]);
    
        // }else{
        //   this.router.navigate(["/app/flight"]);
    
        // }
      },error : (err) => {
        // if(this.tripEnable){
        //    this.router.navigate(["/app/flight"]);

        // }else{
        //     this.router.navigate(["/app/flight"]);

        // }
          console.error("Error in fetching data");
        }
      }
    )
    
  }
  terminalClick(){
  window.location.href="/app/terminal"
  }
  switchBack(){

   // window.location.href = "/app/flight?name="+this.transformEmail(element)
    //this.router.navigate(['/app/flight'], { queryParams:  element });   
    let request = this.userInfoService.getParentUser()
    if(request){
        this.userInfoService.setToken(request);
       // this.router.navigate(["/app/flight"]);
        window.location.href = "/app/flight"
        
    }
}

loginErrorResponseStatus(res : any) {
  if(res.status==401) {
    this.invalidCredentialMsg=true;
  } 
  }
  aisedTicket(){
    this.router.navigate(["/app/raisedTicket"]);
  }
  EmulateUser(){
    //  console.log(element)
     // window.location.href = "/app/flight?name="+this.transformEmail(element)
      //this.router.navigate(['/app/flight'], { queryParams:  element });   
      const request = {username:this.emulateEmail,action:"emulate"}
      this.loginService.regenerate(request)
      .subscribe({next : (res:any)=> {
        //console.log(res)
        if(res) { 
         if(res.token) {
          let parentUser=undefined;
          if(res.parentUser){
            parentUser = res.parentUser
          }
          this.userInfoService.setToken(res.token);
          
          // window.location.href="/app/flight"
          if(this.tripEnable){
            window.location.href="/app/trip"
      
          }else{
            window.location.href="/app/flight"
      
          }
        //  this.router.navigate(["/app/flight"]);
         // const userData:any = jwt(body["token"]);
        
        }
        } else {
          this.emulateErrorResponseStatus(res);
        }
    }, error : (err:any)=> {
      this.emulateErrorResponseStatus(err);
    }})
  }
  
  emulateErrorResponseStatus(res : any) {
    if(res.status==401) {
      //this.invalidCredentialMsg=true;
    } 
  }
  isActive(route: string): boolean {
    return this.router.isActive(route, true);
  }
  onlogoClick(){
    if(this.tripEnable){
      window.location.href="/app/trip"

    }else{
      window.location.href="/app/flight"

    }

  }


  totalBalance:any
  GetBalance(){

    this.PaymentConfigService
    .getMBalance(this.userUuid)
    .subscribe({
      next : (res:any) => {
        if(res) {
       let data=res
       this.totalBalance=data
       
        } else {
        
        } 
      },error : (err) => {
  
      }
    }
  )
  }
  // elem=document.documentElement

  // openfullscreen() {

  //   this.fullScreen(document.documentElement);
  //   }
  // fullScreen(elem:any){
  //   console.log(this.elem.requestFullscreen)

  //   if(elem.requestFullscreen) {
  //     elem.requestFullscreen();
  //     } else if(elem.mozRequestFullScreen) {
  //       elem.mozRequestFullScreen();
  //     } else if(elem.webkitRequestFullscreen) {
  //       elem.webkitRequestFullscreen();
  //     } else if(elem.msRequestFullscreen) {
  //       elem.msRequestFullscreen();
  //     }



  // sessionStorage.setItem('fullscreen', 'true');


  // }
  // exitFullScreen(){
  //   if(document.exitFullscreen){
  //     document.exitFullscreen()  
  //     }
  //     sessionStorage.setItem('fullscreen', 'false');

  // }

  visible: boolean = false;

  showDialog() {
    this.amount=0
      this.visible = true;
  }
  amount: any;
  currency: string = 'INR';
  initiatePayment() {

    sessionStorage.setItem('urlAgentPath',this.router.routerState.snapshot.url);

    const paymentDetails = {
      amount: this.amount,
      currency: this.currency,
      pgPaymentPurpose:'AB',
      // redirectUrl: this.router.navigate(["/app/flight"]),
      // cancelUrl: this.router.navigate(["/app/flight"])
    };
    
    this.loginService.initiatePayment(paymentDetails).subscribe(response => {
      // Handle the response and redirect to CCAvenue payment page

      const { accessCode, encRequest } = response.body;
      

      const form = document.createElement('form');
      form.method = 'POST';
      form.action = environment.hdfcUrl+'/transaction/transaction.do?command=initiateTransaction';
      // form.target = '_blank'; // Change target to open in a new window
      form.target = '_self';  

      const accessCodeInput = document.createElement('input');
      accessCodeInput.type = 'hidden';
      accessCodeInput.name = 'access_code';
      accessCodeInput.value = accessCode;
      form.appendChild(accessCodeInput);

      const encRequestInput = document.createElement('input');
      encRequestInput.type = 'hidden';
      encRequestInput.name = 'encRequest';
      encRequestInput.value = encRequest;
      form.appendChild(encRequestInput);

      document.body.appendChild(form);
      form.submit();
      // window.location.href = 'http://localhost:4200/redirect-after-submit';

      // const { accessCode, encryptedData } = response;
      // console.log(accessCode)
      // console.log(encryptedData)

      // const form = document.createElement('form');
      // form.method = 'POST';
      // // form.action = 'https://secure.ccavenue.com/transaction/transaction.do?command=initiateTransaction';

      // form.action = 'https://test.ccavenue.com/transaction/transaction.do?command=initiateTransaction';
      // form.target = '_self';  

      // const accessCodeInput = document.createElement('input');
      // accessCodeInput.type = 'hidden';
      // accessCodeInput.name = 'access_code';
      // accessCodeInput.value = accessCode;
      // form.appendChild(accessCodeInput);

      // const encRequestInput = document.createElement('input');
      // encRequestInput.type = 'hidden';
      // encRequestInput.name = 'encRequest';
      // encRequestInput.value = encryptedData;
      // form.appendChild(encRequestInput);

      // document.body.appendChild(form);
      // form.submit();
    });
  }
  onlyNumberKey(event:any) {
     
    let charCode = (event.which) ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31
        && (charCode < 48 || charCode > 57))
        return false;
    return true;
  }




  onClickAgentDash(){
    // this.router.navigate(["/app/agent-dashboard"]);
    // this.router.navigate(["https://ai.gilpinonline.com/app/Dashboard"]);
    // let url="https://ai.gilpinonline.com/app/Dashboard"
    this.crossdomainauth()

  }

  crossdomainauth(){
    this.loginService
    .crossdomainauth()
    .subscribe({
      next : (res:any) => {
        if(res) {
          const data = res
          if(res.requestId){
            let url:any
           url="https://vaptai.gilpinonline.com/log-in/"+res.requestId
          window.open(url, '_blank');
        }
         } else {

         } 
      },error : (err) => {

        console.error("Error in fetching result");
      }
    })}
  onClickTrip(element:any){
    this.router.navigate(['/app/trip']);

  }
  onClickQTGTrip(){
    this.router.navigate(["/app/trip-summary"]);

  }
  SOPPDF(name:any,filename:any){
    this.DocumentService
    .downloadDoc(this.userUuid)
    .subscribe({
      next : (res:any) => {
        console.log(res)
        if(res) {
         let data:any
         data=res
        //  console.log(data)
  
  console.log(data)
        var fileName = filename;
  var blob = data.body;
  const file = new Blob([blob], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  
  var a = document.createElement("a");
  a.href = window.URL.createObjectURL(file);
  a.download = fileName;
  window.open(a.href, '_blank');
  // // Append the link to the document
  // document.body.appendChild(a);
  
  // // Trigger a click on the link to start the download
  // a.click();
  
  // Remove the link from the document after the download is initiated
  document.body.appendChild(a);
  document.body.removeChild(a);
  
  // Revoke the object URL to avoid memory leaks
  // window.URL.revokeObjectURL(a.href);
        } else {    

        } 
      },error : (err) => {
        console.log(err)
  
  
      }
    }
  )
  
  }
  
tripResponse:any
  getActiveTripList(){
    this.TripService
    .getActiveTrip( this.userUuid)
    .subscribe({
      next : (res:any) => {
        if(res) {
          const data = res
          this.tripResponse={
            tripName:data?.tripName,
            tripUid:data?.tripUid
          }
         
         } else {

         } 
      },error : (err) => {

        console.error("Error in fetching result");
      }
    })}
  
}
